import axios from 'axios';

const Upgrade = {
    upgrade: (courseId, userId, code) =>
        axios.post('upgrade', { courseId, userId, accessCode: code })
}

export default Upgrade;